import { SendGETUserAPI } from "../../customFunctions/Api.js";

export default {
    state: {
        userData: localStorage.getItem("user"),
        apiKey: '',
        accessToken: "",
        authHeaderForServerAPIRequest: {},
        refreshToken: localStorage.getItem('rToken'),
        apiRefreshToken: localStorage.getItem('apiRefreshToken'),
        isLogined: false,
        checkAliveId: null,
        userEmail: '',
        userPassword: ''
    },
    actions: {
        async setApiKey(ctx, state) {
            if (!state.security.apiKey) {
                const getApiKey = await SendGETUserAPI(
                    "users/" + state.security.userData.id + "/api-key",
                    {
                        Authorization: "Bearer " + state.security.accessToken,
                    }
                );
                ctx.commit('setApiKeyMutation', getApiKey.apiKey)
            }
        }
    },
    mutations: {
        setUserDataMutation(state, values) {
            state.userData = values
        },
        setAccessTokenMutation(state, values) {
            state.accessToken = values
        },
        setAuthHeaderForServerAPIRequestMutation(state, values) {
            state.authHeaderForServerAPIRequest = values
        },
        setRefreshTokenMutation(state, values) {
            state.refreshToken = values
        },
        setIsLoginedMutation(state, values) {
            state.isLogined = values
        },
        setUserEmailMutation(state, values) {
            state.userEmail = values
        },
        setUserPasswordMutation(state, values) {
            state.userPassword = values
        },
        setApiRefreshTokenMutation(state, values) {
            state.apiRefreshToken = values
        },
        setAllSecurityValuesNullMutation(state) {
            state.userData = {},
                state.accessToken = "",
                state.authHeaderForServerAPIRequest = {},
                state.refreshToken = "",
                state.isLogined = false,
                state.apiKey = ""
        },
        setApiKeyMutation(state, values) {
            state.apiKey = values
        }
    },
    getters: {
        getUserData(state) {
            return state.userData;
        },
        getAccessToken(state) {
            return state.accessToken;
        },
        getAuthHeaderForServerAPIRequest(state) {
            return state.authHeaderForServerAPIRequest;
        },
        getRefreshToken(state) {
            return state.refreshToken;
        },
        getIsLogined(state) {
            return state.isLogined;
        },
        getCheckAliveId(state) {
            return state.checkAliveId;
        },
        getUserEmail(state) {
            return state.userEmail;
        },
        getUserPassword(state) {
            return state.userPassword;
        },
        getApiRefreshToken(state) {
            return state.apiRefreshToken;
        },
        getApiKey(state) {
            return state.apiKey;
        },
    },
}